<template>
  <div>
    <b-modal id="modalEditContractType" ref="modalEditContractType" :title="$t('Contract type detail')" hide-footer>
      <div v-if="editItem">
        <b-form-group label-align="right" :label="$t('Full name')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-input type="text" v-model="editItem.name" aria-describedby="inputFeedbackName" :state="editItem.name.length > 0"/>
          <b-form-invalid-feedback id="inputFeedbackName">
            {{ $t('Enter title') }}
          </b-form-invalid-feedback>
        </b-form-group>
        <modal-ok-cancel @save="save" @cancel="$bvModal.hide('modalEditContractType')" />
      </div>
    </b-modal>
  </div>
</template>

<script>
export default {
  props: {
    editItem: null
  },
  methods: {
    save () {
      if (!this.editItem.name) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Full name fields is invalid'), 'Error')
        return
      }
      this.editItem.contract_type_id = this.editItem.id
      let response = this.editItem.id !== 0
        ? this.$store.dispatch('Tariffing/UPDATE_CONTRACT_TYPE', this.editItem)
        : this.$store.dispatch('Tariffing/CREATE_CONTRACT_TYPE', this.editItem)
      response.then(response => {
        if (response.data.error) {
          this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
        } else {
          setTimeout(this.$store.dispatch, 500, 'Tariffing/GET_CONTRACT_TYPE')
          this.$refs.modalEditContractType.hide()
          this.$root.$emit('makeToasts')
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/tariffication/other/contractType/editModal.vue